import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { scrollToElementById, scrollToTop } from '../utils/scroll';

/**
 * Scrolls to top on route change; scrolls to hash targets when present.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    const id = hash ? hash.replace('#', '') : '';

    if (id) {
      const timer = window.setTimeout(() => scrollToElementById(id), 50);
      return () => window.clearTimeout(timer);
    }

    scrollToTop();
  }, [pathname, hash]);

  return null;
}
